import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@airia/ui';
import ReactMarkdown from 'react-markdown';
import { parseEmailTags } from '../../lib/emailParser';
import EmailButton from './EmailButton';
import ReplyEmailButton from './ReplyEmailButton';
import ReplaceEmailButton from './ReplaceEmailButton';
const IndividualMessage = ({ message }) => {
    const messageParts = parseEmailTags(message.value);
    const renderMessagePart = (part, index) => {
        if (part.type === 'email' && part.emailData) {
            return _jsx(EmailButton, { emailData: part.emailData }, `email-${index}`);
        }
        if (part.type === 'reply' && part.replyEmailData) {
            return _jsx(ReplyEmailButton, { replyEmailData: part.replyEmailData }, `reply-${index}`);
        }
        if (part.type === 'replace' && part.replaceEmailData) {
            return (_jsx(ReplaceEmailButton, { replaceEmailData: part.replaceEmailData }, `replace-${index}`));
        }
        return (_jsx(ReactMarkdown, { components: {
                p: ({ children }) => _jsx("p", { className: "mb-2 last:mb-0", children: children }),
                h1: ({ children }) => (_jsx("h1", { className: "text-lg font-semibold mb-2", children: children })),
                h2: ({ children }) => (_jsx("h2", { className: "text-base font-semibold mb-2", children: children })),
                h3: ({ children }) => (_jsx("h3", { className: "text-sm font-semibold mb-1", children: children })),
                ul: ({ children }) => _jsx("ul", { className: "list-disc pl-4 mb-2", children: children }),
                ol: ({ children }) => _jsx("ol", { className: "list-decimal pl-4 mb-2", children: children }),
                li: ({ children }) => _jsx("li", { className: "mb-1", children: children }),
                code: ({ children, className }) => {
                    const isInline = !className;
                    if (isInline) {
                        return (_jsx("code", { className: "bg-muted px-1 py-0.5 rounded text-xs font-mono", children: children }));
                    }
                    return (_jsx("pre", { className: "bg-muted p-3 rounded-lg overflow-x-auto mb-2", children: _jsx("code", { className: "text-xs font-mono", children: children }) }));
                },
                blockquote: ({ children }) => (_jsx("blockquote", { className: "border-l-4 border-primary pl-4 italic mb-2", children: children })),
                strong: ({ children }) => _jsx("strong", { className: "font-semibold", children: children }),
                em: ({ children }) => _jsx("em", { className: "italic", children: children }),
                a: ({ children, href }) => (_jsx("a", { href: href, className: "text-primary hover:underline", target: "_blank", rel: "noopener noreferrer", children: children })),
            }, children: part.content }, `text-${index}`));
    };
    return (_jsx("div", { className: cn('p-2 rounded-lg flex flex-col gap-1', {
            'self-start bg-card text-card-foreground': message.role === 'assistant',
            'self-end bg-muted text-muted-foreground': message.role === 'user',
        }), children: _jsxs("div", { className: cn('flex gap-2', { 'self-end': message.role === 'user' }), children: [_jsx("div", { className: 'flex pt-1', children: message.role === 'assistant' && (_jsx("img", { alt: 'Airia', src: '/assets/airia-logo.svg', className: 'size-4 min-w-4' })) }), _jsx("div", { className: cn('prose prose-sm max-w-none prose-gray dark:prose-invert', {
                        'text-right': message.role === 'user',
                    }), children: messageParts.map((part, index) => renderMessagePart(part, index)) })] }) }));
};
export default IndividualMessage;
